import React, { createRef } from "react";
import { connect } from "react-redux";
import Menu from "../menu";
import { Globals, ENV, Constants, SocketEvents, Colors } from "../../utils";
import { User as UserService } from "../../services";
import axios from '../../utils/axios';
import BusinessIcon from '../../assets/icons/my-business.png';
import ProfileIcon from '../../assets/icons/my-profile.png';
import PictureIcon from '../../assets/icons/image.png';
import socket from '../../utils/socket';
import { Share, InputFormat, Modal, Button, Table, Pagination, Select, Icon } from "../../components";
import TrashIcon from '../../assets/icons/trash.png';
import GearIcon from '../../assets/icons/gear.png';
import BagIcon from '../../assets/icons/bag.png';
import BtnEdit from '../../assets/icons/btn-edit.png';
import TabBottom from '../../assets/icons/tab-bottom.png';
import PlanImage from '../../assets/img/plan-image.png';
import PublicHeader from '../../assets/icons/public-header.png';
import PublicImage from '../../assets/icons/public-image.png';
import PublicFooter from '../../assets/icons/public-footer.png';
import AddIcon from '../../assets/icons/add2.png';
import CalendarIcon from '../../assets/icons/calendar.png';
import ApiGuide from '../../screens/docu/api_guide';
import PrinterType from '../../screens/printer-type/printer-type';
import moment from 'moment';
import ModalDiscount from './components/discounts/ModalDiscount';
import ModalCommission from './components/commissions/ModalCommission';
import ProductsPromotedList from './components/productsPromoted/ProductsPromotedList';
import ProductsLimitedList from './components/productsLimited/ProductsLimitedList';

const DISCOUNT_NAME_LENGTH = 30;

const SHOW_PRICES = {
	YES: 1,
	NO: 0
}

const ACCEPT_ORDER_BEFORE = {
	YES: 1,
	NO: 0
}

const NEGATIVE_STOCK = {
	YES: 1,
	NO: 0
}

const USE_NULL_ZONES = {
	YES: 1,
	NO: 0
}

const SHOW_ORDER_TOTAL = {
	YES: 1,
	NO: 0
}

const ALLOW_SELLER_DISCOUNT = {
	YES: 1,
	NO: 0
}

const ALLOW_SELLER_PRODUCT_DISCOUNT = {
	YES: 1,
	NO: 0
}

const ALLOW_SELLER_CREDIT_DAYS = {
	YES: 1,
	NO: 0
}

const RESTRICT_CREDIT_LIMIT = {
	YES: 1,
	NO: 0
}

const PUBLIC_TABS = {
	HEADER: 1,
	IMAGE: 2,
	FOOTER: 3
}

const TABS = {
	ACCOUNT: 1,
	BUSINESS: 2,
	GENERAL_CONFIGS: 3,
	SHOP: 4
}

const SETTINGS_TABS = {
	GENERAL: 1,
	API: 2,
	CUSTOM: 3,
	DISCOUNTS: 4,
	COMMISSIONS: 5
}

const TABS_CUSTOM = {
	ACCOUNTS: 1,
	SELL: 2,
	COMMISSIONS: 3
}

class MyProfileAccount extends React.Component {

	state = {
		// tab: this.props.user.level_id === Constants.ROLE_ADMIN ? TABS.BUSINESS : TABS.ACCOUNT,
		tab: TABS.ACCOUNT,
		form: {
			logo: {},
			logoUrl: '',
			password: '',
			confirmPassword: '',
			name: '',
			email: '',
			document: '',
			phone: '',
			address: '',
			show_prices: SHOW_PRICES.YES,
			url: ENV.BaseStore,
			formattedUrl: '',
			sell_note: '',
			facebook: '',
			instagram: '',
			twitter: '',
			header_bg: '#C70FB1',
			footer_bg: '#333333',
			banner: '',
			bannerUrl: '',
			accept_order_before: ACCEPT_ORDER_BEFORE.NO,
			negative_stock: NEGATIVE_STOCK.NO,
			use_null_zones: USE_NULL_ZONES.YES,
			percentage: '',
			iva_id: null,
			referral_link: '',
			formattedReferralLink: '',
			formattedReferralLinkWithoutRegister: '',
			show_order_total: '',
			general_discounts: [],
			allow_seller_discount: ALLOW_SELLER_DISCOUNT.YES,
			allow_seller_product_discount: ALLOW_SELLER_PRODUCT_DISCOUNT.YES,
			allow_seller_credit_days: ALLOW_SELLER_CREDIT_DAYS.YES,
			restrict_credit_limit: RESTRICT_CREDIT_LIMIT.YES,
			seller_credit_days_default: '',
		},
		currentURL: ENV.BaseStore,
		store_session: `${this.props.user.id}-${Date.now()}`,
		photo_error: false,
		public_tab: PUBLIC_TABS.HEADER,
		plan_name: '',
		plan_expiration: undefined,
		plan_free: false,
		tab_settings: SETTINGS_TABS.GENERAL,
		methods: [],
		tab_custom: TABS_CUSTOM.SELL,
		showDiscountModal: false,
		selectedDiscount: null,
		newDiscountName: '',
		countryEquivalent: Globals.getUserCountryEquivalent(),
		hasPendingPayments: true,
		discount_page: 1,
		discount_last_page: 1,
		discount_filter_type: '',
		list_discount_types: [
			{ value: '', label: 'Todos' },
			{ value: 'general', label: 'Descuento general' },
			{ value: 'surtido', label: 'Por surtido' },
			{ value: 'volumen', label: 'Por volumen' },
			{ value: 'pronto_pago', label: 'Por pronto pago' },
			{ value: 'ruta_vendedor', label: 'Por Zona/Vendedor' },
			{ value: 'surtido_volumen', label: 'Surtido y volumen' },
			//{ value: 'limite_cantidad', label: 'Por límite de cantidad con precio especial' },
		],
		showCommissionModal: false,
		selectedCommission: null,
		commission_page_sellers: 1,
		commission_page_managers: 1,
		sellers_commissions: [],
		managers_commissions: [],
		commission_filter_type: '',
		list_commission_types: [
			{ value: '', label: 'Todos' },
			{ value: '1', label: 'Por fecha de pagos' },
			{ value: '2', label: 'Por categoría' },
			{ value: '3', label: 'Por producto' },
		],
	};

	constructor(props) {
		super(props);

		this.printerTypeComponent = React.createRef();
	}

	componentDidMount() {
		this.assignForm();
		this.load();
	}

	debounce = createRef();

	load = async () => {
		Globals.setLoading();

		try {
			const res = await UserService.getAdminProfile({
				user_id: this.props.user.id
			});

			if (!res.user) throw new Error('Ocurrió un error inesperado');

			await this.setState({
				form: {
					...this.state.form,
					show_prices: res.public_store?.show_prices,
					url: res.public_store?.url || '',
					facebook: res.user.facebook || '',
					instagram: res.user.instagram || '',
					twitter: res.user.twitter || '',
					header_bg: res.public_store?.header_bg || '#C70FB1',
					footer_bg: res.public_store?.footer_bg || '#333333',
					banner: res.public_store?.banner || '',
					bannerUrl: res.public_store?.banner ? Globals.fromPhotos(res.public_store.banner) : '',
					accept_order_before: res.user.accept_order_before,
					percentage: res.iva?.percentage || this.state.countryEquivalent.defaultIvaAmount || '',
					iva_id: res.iva?.id || '',
					referral_link: res.user.referral_link || '',
					show_order_total: res.user.show_order_total,
					negative_stock: res?.config?.negative_stock,
					use_null_zones: res?.config?.use_null_zones,
					//general_discounts: res?.general_discounts || [],
					allow_seller_discount: res?.config?.allow_seller_discount ?? ALLOW_SELLER_DISCOUNT.YES,
					allow_seller_product_discount: res?.config?.allow_seller_product_discount ?? ALLOW_SELLER_PRODUCT_DISCOUNT.YES,
					allow_seller_credit_days: res?.config?.allow_seller_credit_days ?? ALLOW_SELLER_CREDIT_DAYS.YES,
					restrict_credit_limit: res?.config?.restrict_credit_limit ?? RESTRICT_CREDIT_LIMIT.YES,
					seller_credit_days_default: res?.config?.seller_credit_days_default ?? '',
				},
				currentURL: ENV.BaseStore + (res.public_store?.url || ''),
				plan_name: res.plan_name || '',
				plan_expiration: res.plan_expiration || undefined,
				plan_free: res.plan_free || false,
				plan_user: res.plan_user || null,
				methods: res.methods || [],
				hasPendingPayments: res.has_pending_payments,
			});
			await this.formatUrl();

		} catch (error) {
			console.log(error);
			Globals.showError('Ocurrió un error inesperado');
		}

		Globals.quitLoading();
	}

	assignForm = async () => {
		await this.setState({
			form: {
				...this.state.form,
				logoUrl: this.props.user.logo ? Globals.fromPhotos(this.props.user.logo) : '',
				name: this.props.user?.name || '',
				email: this.props.user?.email || '',
				document: this.props.user?.document || '',
				phone: this.props.user?.phone || '',
				address: this.props.user?.address || '',
				sell_note: this.props.user?.sell_note || '',
				facebook: this.props.user?.facebook || '',
				instagram: this.props.user?.instagram || '',
				twitter: this.props.user?.twitter || '',
			}
		});
	}

	onChangeEvent = async (event) => {
		const target = event.target.name;
		const value = event.target.value;

		await this.setState(state => ({
			form: { ...state.form, [target]: value }
		}));

		if (!['header_bg', 'footer_bg'].includes(target)) return;

		if (this.debounce.current) clearTimeout(this.debounce.current);
		this.debounce.current = setTimeout(async () => {
			socket.emit(SocketEvents.PUBLIC_STORE.PREVIEW.COLORS, {
				header_bg: this.state.form.header_bg,
				footer_bg: this.state.form.footer_bg,
				store_session: this.state.store_session,
			});
		}, 500);
	}

	onChange = async (value, target) => {
		await this.setState(state => ({
			form: {
				...state.form,
				[target]: !!value?.target ? value?.target?.value : value,
			}
		}));

		const autoSaveTargets = ['accept_order_before', 'negative_stock', 'use_null_zones', 'show_order_total', 'allow_seller_discount', 'allow_seller_product_discount', 'allow_seller_credit_days', 'restrict_credit_limit', 'seller_credit_days_default'];
		if (autoSaveTargets.includes(target)) {
			this.onSubmit();
		}
	}

	formatUrl = async () => {
		const currentOrigin = `${window.location.origin}${window.location.pathname}`; // Obtiene el origen y la ruta actual

		await this.setState(state => ({
			form: {
				...state.form,
				formattedUrl: ENV.BaseStore + state.form.url,
				formattedReferralLink: `${currentOrigin}#/register${state.form.referral_link}`, // Enlace de referido

				/*
				// Remueve "-" seguido del ID
				formattedReferralLinkWithoutRegister: `${currentOrigin}#/${
					state.form.referral_link.replace(/-\d+$/, '')  // <- Cambio clave aquí
				}`,
				*/
				formattedReferralLinkWithoutRegister: `${currentOrigin}#/${state.form.referral_link.replace(/^\d+/, '') // <- Cambio clave aquí
					}`
			}
		}));
	}


	uploadPhoto = async (e) => {
		const currentFile = URL.createObjectURL(e.target.files[0]);
		await this.onChange(e.target.files[0], 'logo');
		await this.onChange(currentFile, 'logoUrl');
		await this.setState({ photo_error: false });
	}

	setTab = (tab) => {
		this.setState({ tab });
	}

	onSubmit = async () => {
		if (!this.isValidForm()) return;
		Globals.setLoading();
		const data = {
			web: true,
			user_id: this.props.user.id,
			...this.state.form,
			hasFile: true,
			methods: JSON.stringify(this.state.methods.filter(i => i.active).map(i => i.id)),
			//general_discounts: JSON.stringify(this.state.form.general_discounts),
			sell_note: String(this.state.form.sell_note).split('\n').map(i => i.trim()).join('\n'),
		}
		console.log(data)

		try {
			const res = await UserService.editAdminProfile({
				web: true,
				user_id: this.props.user.id,
				...this.state.form,
				hasFile: true,
				methods: JSON.stringify(this.state.methods.filter(i => i.active).map(i => i.id)),
				//general_discounts: JSON.stringify(this.state.form.general_discounts),
				sell_note: String(this.state.form.sell_note).split('\n').map(i => i.trim()).join('\n'),
			});

			if (!res.user) throw new Error('Ocurrió un error inesperado');

			this.props.dispatch({
				type: 'SET_USER',
				payload: res.user,
			});

			this.setState({
				form: { ...this.state.form, password: '', confirmPassword: '' },
			});

			Globals.showSuccess('Se han guardado los cambios');

		} catch (error) {
			console.log(error);
			Globals.showError(error?.error || 'Ocurrió un error inesperado');
		}

		Globals.quitLoading();

		this.printerTypeComponent.current?.submit();

		if (this.props.user.level_id === Constants.ROLE_ADMIN) {
			socket.emit(SocketEvents.UPDATE_SUPERADMIN, { admin_id: this.props.user.id });
		}

		this.load();
	}

	isValidForm = () => {
		const onError = (message) => {
			Globals.showError(message);
			return false;
		}

		const { form } = this.state;

		if (!form.email) {
			return onError('El correo es obligatorio');
		}

		if (!!form.password || !!form.confirmPassword) {
			if (!form.password)
				return onError('La contraseña es obligatoria');

			if (form.password !== form.confirmPassword)
				return onError('Las contraseñas no coinciden');
		}

		if (this.props.user.level_id === Constants.ROLE_ADMIN) {
			// if (!form.url){
			// 	return onError('La URL es obligatoria');
			// }	

			if (form.url.includes(' ')) {
				return onError('La URL no puede tener espacios en blanco');
			}
		}

		return true;
	}

	shareURL = () => {
		if (!navigator.share)
			return Globals.showError('Tu navegador no permite esta función');

		try {
			navigator.share({
				title: 'Catálogo Virtual',
				url: this.state.form.formattedUrl,
			});

		} catch (error) {
			console.log(error)
		}
	}

	onUploadBanner = async (e) => {
		if (!e.target.files[0]) return;
		if (!['image/jpeg', 'image/png', 'image/gif'].includes(e.target.files[0].type))
			return Globals.showError('La imagen debe ser formato JPG o PNG');
		if (e.target.files[0].size > 500000)
			return Globals.showError('La imagen no puede pesar más de 500KB');

		const currentFile = URL.createObjectURL(e.target.files[0]);
		const file = new FileReader();
		file.readAsDataURL(e.target.files[0]);
		file.onload = () => {
			socket.emit(SocketEvents.PUBLIC_STORE.PREVIEW.BANNER, {
				banner: file.result,
				store_session: this.state.store_session,
			});
		}
		await this.onChange(e.target.files[0], 'banner');
		await this.onChange(currentFile, 'bannerUrl');
	}

	onRemoveBanner = async () => {
		await this.onChange('', 'banner');
		await this.onChange('', 'bannerUrl');
		document.getElementById('banner-image').value = null;
		socket.emit(SocketEvents.PUBLIC_STORE.PREVIEW.BANNER, {
			banner: null,
			store_session: this.state.store_session,
		});
	}

	setPublicTab = (tab) => {
		this.setState({
			public_tab: tab
		});
	}

	setSettingsTab = (tab) => {
		this.setState({
			tab_settings: tab
		});

		if (tab === SETTINGS_TABS.DISCOUNTS) {
			this.getDiscounts();
		}
		if (tab === SETTINGS_TABS.COMMISSIONS) {
			this.getCommissions();
		}
	}

	getCommissions = async (page_sellers = 1, page_managers = 1) => {
		Globals.setLoading();
		try {
			const res = await axios.post('admin/commissions/get', {
				user_id: this.props.user.id,
				type: this.state.commission_filter_type,
				page_sellers,
				page_managers
			});

			this.setState({
				sellers_commissions: res.data.sellers?.data || [],
				managers_commissions: res.data.managers?.data || [],
				commission_page_sellers: page_sellers,
				commission_page_managers: page_managers,
			});
		} catch (error) {
			console.log('MyProfileAccount -> getCommissions: ', error);
		}
		Globals.quitLoading();
	}

	removeCommission = (id) => {
		Globals.confirm('¿Está seguro de que desea eliminar esta comisión?', () => {
			Globals.setLoading("Eliminando...");
			axios
				.post('admin/commissions/delete', { id })
				.then(res => {
					if (res.data.result) {
						Globals.showSuccess('Comisión eliminada correctamente');
						this.getCommissions(this.state.commission_page_sellers, this.state.commission_page_managers);
					} else {
						Globals.showError(res.data.error || 'Ocurrió un error al eliminar');
					}
				})
				.catch(error => {
					console.log(error);
					const msg = error.response?.data?.error || 'Ocurrió un error inesperado al eliminar';
					Globals.showError(msg);
				})
				.then(() => {
					Globals.quitLoading();
				});
		});
	}

	getDiscounts = async (page = 1) => {
		Globals.setLoading();
		try {
			const resDiscounts = await axios.post('admin/discounts/get', {
				user_id: this.props.user.id,
				type: this.state.discount_filter_type,
				page
			});

			const general_discounts = resDiscounts.data.discounts.data || [];

			this.setState(state => ({
				form: {
					...state.form,
					general_discounts
				},
				discount_page: page,
				discount_last_page: resDiscounts.data.discounts.last_page || 1
			}));
		} catch (error) {
			console.log('MyProfileAccount -> getDiscounts: ', error);
		}
		Globals.quitLoading();
	}

	getDiscountTypeBadge = (discount) => {
		const type = typeof discount === 'string' ? discount : discount?.type;
		switch (type) {
			case 'surtido': return <span style={{ color: '#007bff', background: '#e6f2ff', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Por surtido</span>;
			case 'surtido_volumen': return <span style={{ color: '#6f42c1', background: '#f3e8ff', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Por surtido y volumen</span>;
			case 'volumen': return <span style={{ color: '#28a745', background: '#e6ffe6', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Por volumen</span>;
			case 'pronto_pago': return <span style={{ color: '#fd7e14', background: '#fff0e6', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Por pronto pago</span>;
			case 'ruta_vendedor':
				let text = "Por Zona/Vendedor";
				if (discount && discount.discount_details && discount.discount_details.length > 0) {
					const hasZone = discount.discount_details.some(d => d.zone_id);
					const hasSeller = discount.discount_details.some(d => d.seller_id);
					if (hasZone && !hasSeller) {
						text = "Por Zona";
					} else if (!hasZone && hasSeller) {
						text = "Por Vendedor";
					}
				}
				return <span style={{ color: '#6f42c1', background: '#f0e6ff', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>{text}</span>;
			//case 'limite_cantidad': return <span style={{ color: '#e83e8c', background: '#ffe6f0', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Por límite de cantidad con precio especial</span>;
			case 'general': return <span style={{ color: '#ffc107', background: '#fff9e6', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Descuento general</span>;
			default: return <span style={{ color: '#6c757d', background: '#f8f9fa', padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold' }}>Desconocido</span>;
		}
	}

	getCommissionTypeBadge = (type) => {
		switch (String(type)) {
			case '1': return <span style={{ color: '#28a745', background: '#e6ffe6', padding: '5px 12px', borderRadius: '15px', fontWeight: 'bold', fontSize: '13px' }}>Por fecha de pago</span>;
			case '2': return <span style={{ color: '#fd7e14', background: '#fff0e6', padding: '5px 12px', borderRadius: '15px', fontWeight: 'bold', fontSize: '13px' }}>Por categoría</span>;
			case '3': return <span style={{ color: '#007bff', background: '#e6f2ff', padding: '5px 12px', borderRadius: '15px', fontWeight: 'bold', fontSize: '13px' }}>Por productos</span>;
			default: return <span style={{ color: '#6c757d', background: '#f8f9fa', padding: '5px 12px', borderRadius: '15px', fontWeight: 'bold', fontSize: '13px' }}>Desconocido</span>;
		}
	}

	toggleCommissionStatus = (detail) => {
		const newStatus = detail.commission.is_active ? 0 : 1;

		const changeStatus = () => {
			Globals.setLoading();
			axios.post('admin/commissions/create-update', {
				user_id: this.props.user.id,
				id: detail.commission.id,
				is_active: newStatus,
			}).then(res => {
				if (res.data.result) {
					this.getCommissions(this.state.commission_page_sellers, this.state.commission_page_managers);
				} else {
					Globals.showError(res.data.error);
				}
			}).catch(error => {
				Globals.showError('Ocurrió un error inesperado');
			}).then(() => Globals.quitLoading());
		};

		if (newStatus === 0) {
			Globals.confirm(
				"Al suspender esta comisión, tenga en cuenta que no se aplicará a pedidos que establezcan este período de pagos",
				changeStatus
			);
		} else {
			changeStatus();
		}
	}

	setTabCustom = (tab) => {
		this.setState({
			tab_custom: tab
		});
	}

	changeIVA = e => {
		// Limitar los números enteros a 8
		let nums = String(e.value).split('.', 2);
		let value = nums[0].substring(0, 8);
		value = `${value}${nums[1] ? `.${nums[1]}` : ''}`;

		this.setState({
			form: {
				...this.state.form,
				percentage: value
			}
		});
	}

	setMethodActive = (index) => {
		let methods = [...this.state.methods];
		methods[index].active = !methods[index].active;
		this.setState({
			methods
		});
	}

	toViewPayments = () => {

	}

	toChangePlan = () => {
		if (this.state.hasPendingPayments)
			return Globals.showError('Usted presenta un pago aun por confirmar');

		this.props.history.push("/profile-business/plans");
	}

	toPay = () => {
		if (this.state.hasPendingPayments)
			return Globals.showError('Usted presenta un pago aun por confirmar');

		this.props.history.push("/profile-business/payment");
	}

	// Métodos para manejar descuentos
	changeStatusDiscount = (discount, index) => {
		if (!discount.id) {
			Globals.showError('Debe guardar el descuento antes de cambiar su estado.');
			return;
		}

		const isActive = discount.status === Constants.STATUS_ACTIVE;
		const message = isActive
			? `¿Desea inactivar el descuento ${discount.name}?`
			: `¿Desea activar el descuento ${discount.name}?`;

		Globals.confirm(message, () => {
			Globals.setLoading("Guardando...");
			axios
				.post("admin/discounts/change-status", {
					id: discount.id,
					status: isActive ? Constants.STATUS_INACTIVE : Constants.STATUS_ACTIVE
				})
				.then(res => {
					Globals.showSuccess(res.data.message || 'El estado ha sido actualizado correctamente.');

					this.setState(prevState => {
						const discounts = [...prevState.form.general_discounts];
						const newStatus = isActive ? Constants.STATUS_INACTIVE : Constants.STATUS_ACTIVE;
						discounts[index] = {
							...discounts[index],
							status: newStatus,
							status_text: newStatus === Constants.STATUS_ACTIVE ? 'Activo' : 'Inactivo'
						};
						return { form: { ...prevState.form, general_discounts: discounts } };
					});
				})
				.catch(err => Globals.showError(err.response?.data?.error || 'Ocurrió un error al actualizar el estado.'))
				.then(() => Globals.quitLoading());
		});
	};

	removeDiscount = (index) => {
		const discount = this.state.form.general_discounts[index];
		if (!discount.id) {
			this.setState(prevState => {
				const discounts = [...prevState.form.general_discounts];
				discounts.splice(index, 1);
				return { form: { ...prevState.form, general_discounts: discounts } };
			});
			return;
		}

		Globals.confirm('¿Está seguro de que desea eliminar este descuento? Dejará de aplicarse en los pedidos.', () => {
			Globals.setLoading("Eliminando...");
			axios
				.post('admin/discounts/delete', { id: discount.id })
				.then(res => {
					if (res.data.success) {
						Globals.showSuccess(res.data.message || 'Descuento eliminado correctamente');
						this.setState(prevState => {
							const discounts = [...prevState.form.general_discounts];
							discounts.splice(index, 1);
							return { form: { ...prevState.form, general_discounts: discounts } };
						});
					} else {
						Globals.showError(res.data.error || 'Ocurrió un error al eliminar');
					}
				})
				.catch(error => {
					console.log(error);
					const msg = error.response?.data?.error || 'Ocurrió un error inesperado al eliminar';
					Globals.showError(msg);
				})
				.then(() => {
					Globals.quitLoading();
				});
		});
	}

	render() {
		const { history } = this.props;
		const { form, tab, tab_custom } = this.state;
		const photo = this.state.photo_error ? PictureIcon : (form?.logoUrl || PictureIcon);
		const banner = form?.bannerUrl || PictureIcon;

		return (
			<Menu history={history}>


				<div id="my-profile-account">
					{/* <RenewalModal
						isOpen={this.state.isRenewalModalOpen}
						onClose={this.toggleRenewalModal}
						plan_user={this.state.plan_user}
						user={this.props.user}
					/> */}

					<nav>
						<button
							className={tab === TABS.ACCOUNT ? 'active' : ''}
							onClick={() => this.setTab(TABS.ACCOUNT)}
						>
							<img src={ProfileIcon} alt="Mi cuenta" />
							<span>Mi Cuenta</span>
						</button>
						{this.props.user.level_id === Constants.ROLE_ADMIN && (
							<>
								<button
									className={tab === TABS.BUSINESS ? 'active' : ''}
									onClick={() => this.setTab(TABS.BUSINESS)}
								>
									<img src={BusinessIcon} alt="Mi negocio" />
									<span>Mi Negocio</span>
								</button>
								<button
									className={tab === TABS.SHOP ? 'active' : ''}
									onClick={() => this.setTab(TABS.SHOP)}
								>
									<img src={BagIcon} alt="Tienda Web" />
									<span>Tienda Web</span>
								</button>
								<button
									className={tab === TABS.GENERAL_CONFIGS ? 'active' : ''}
									onClick={() => this.setTab(TABS.GENERAL_CONFIGS)}
								>
									<img src={GearIcon} alt="Configuración" />
									<span>Configuración</span>
								</button>
							</>
						)}
					</nav>

					{tab === TABS.ACCOUNT && (
						<main className="account-tab">
							<section>
								<div className="control-group">
									<div className="control w-full">
										<label>Correo</label>
										<input
											name="email"
											value={form.email}
											onChange={this.onChangeEvent}
										/>
									</div>
									<p className="control w-full title-section">Cambiar contraseña</p>
									<div className="row">
										<div className="col-md-6">
											<div className="control">
												<label>Nueva contraseña</label>
												<input
													type="password"
													placeholder="******"
													name="password"
													autoComplete="cc-number"
													value={form.password}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="control">
												<label>Repetir contraseña</label>
												<input
													type="password"
													placeholder="******"
													name="confirmPassword"
													autoComplete="cc-number"
													value={form.confirmPassword}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
									</div>
									<main className="business-tab">
										<section className="catalogue">
											<div className="container-white">
												<section>
													<p className="label">Link de referido</p>
													<div className="url-control">
														<div className="prefix">
															<span>URL</span>
														</div>
														<input
															name="referral_link"
															//value={form.referral_link}
															//value={form.referral_link.replace(/-\d+$/, '')} // Muestra solo el texto sin "-96"
															value={form.referral_link.replace(/^\d+/, '')}
															autoComplete="none"
															onChange={async (event) => {
																await this.onChangeEvent(event);
																await this.formatUrl();
															}}
														/>
														<button onClick={() => Globals.copyToClipboard(this.state.form.formattedReferralLink)} />
													</div>
													{/* <p className="link">{form.formattedReferralLinkWithoutRegister}</p> */}
													<p className="link">{form.formattedReferralLink}</p>
												</section>
											</div>
										</section>

									</main>

								</div>
							</section>

							<section>
								{
									this.props.user.level_id === Constants.ROLE_ADMIN && (
										<div className="container-plan">
											<div>
												{this.state.plan_free ? (
													<h4>Prueba Gratuita</h4>
												) : (
													<h4>{this.state.plan_name} ${Globals.formatMiles(this.state.plan_user?.amount)}</h4>
												)}
												<p>
													<img src={CalendarIcon} alt="Próximo pago" />
													<span>Próximo pago: </span>
													<span>{moment(this.state.plan_expiration).format('DD/MM/YYYY')}</span>
												</p>

												{/* <button className="payments-btn" onClick={this.toViewPayments}>
													Ver Pagos
												</button> */}

												<div className="plan-actions">
													{/* <button className="change-plan-btn" onClick={this.toggleRenewalModal}>
														Renovar Plan
													</button> */}
													{this.state.plan_user?.amount > 0 && (
														<button className="pay-btn" onClick={this.toPay}>
															Pagar
														</button>
													)}
													<button className="change-plan-btn" onClick={this.toChangePlan}>
														Cambiar Plan
													</button>
												</div>
											</div>

											<img className="plan-asset" src={PlanImage} alt="Plan" />
										</div>
									)
								}
							</section>

							<section>
								<div className="actions">
									<button className="save-btn primary" onClick={this.onSubmit}>
										<span>GUARDAR</span>
									</button>
								</div>
							</section>
						</main>
					)}

					{tab === TABS.BUSINESS && (
						<main className="business-tab">
							<section className="profile">
								<div className="avatar-wrapper">
									<div className="filename">Foto de logo</div>
									<p className="filename-subtitle">La imagen debe tener un mínimo de 800px por 800px</p>
									<label className="avatar" htmlFor="upload-photo">
										<img
											src={photo}
											className={(this.state.photo_error || photo === PictureIcon) ? 'placeholder' : ''}
											onError={({ currentTarget }) => {
												this.setState({
													photo_error: true
												});
											}}
											alt="Foto de perfil"
										/>
										<input
											type="file"
											id="upload-photo"
											onChange={this.uploadPhoto}
										/>
										<img src={BtnEdit} className="btn-edit" />
									</label>
								</div>
								<div className="control-group">
									<div className="row">
										<div className="col-md-12">
											<div className="control">
												<label>Nombre</label>
												<input
													name="name"
													value={form.name}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="control">
												<label>{this.state.countryEquivalent.bothDni}</label>
												<input
													name="document"
													value={form.document}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="control">
												<label>Teléfono</label>
												<input
													name="phone"
													value={form.phone}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
										<div className="col-md-12">
											<div className="control">
												<label>Dirección fiscal</label>
												<textarea
													row={4}
													name="address"
													value={form.address}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
										<div className="col-md-12">
											<div className="control w-full">
												<label>Políticas notas de venta</label>
												<textarea
													row={4}
													name="sell_note"
													value={form.sell_note}
													onChange={this.onChangeEvent}
												/>
											</div>
										</div>
									</div>

									<button className="save-btn primary" onClick={this.onSubmit} style={{ margin: '0 auto' }}>
										<span>GUARDAR</span>
									</button>
								</div>
							</section>
						</main>
					)}

					{tab === TABS.SHOP && (
						<main className="business-tab">
							<section className="catalogue">
								{/*<div className="section-big">
									<p>TIENDA PÚBLICA WEB (Catálogo virtual)</p>
								</div>*/}
								<p className="section-label">Dirección pública (como los clientes entrarán a tu página)</p>

								<div className="row">
									<div className="col-md-6">
										<div className="container-white">
											<section>
												<p className="label">Nombre para tu dirección pública</p>
												<div className="url-control">
													<div className="prefix">
														<span>URL</span>
													</div>
													<input
														name="url"
														value={form.url}
														autoComplete="none"
														onChange={async (event) => {
															await this.onChangeEvent(event);
															await this.formatUrl();
														}}
													/>
													<button onClick={() => Globals.copyToClipboard(this.state.form.formattedUrl)} />
												</div>
												<p className="link">{form.formattedUrl}</p>
											</section>
										</div>
									</div>
									<div className="col-md-6">
										<div className="container-white">
											<div className="actions">
												<p>Comparte tu enlace para que puedan ver tu catálogo</p>
												<Share url={form.formattedUrl} />
											</div>
										</div>

										<div className="container-white">
											<div className="show-prices">
												<p>¿Deseas que la Web tenga público los precios?</p>
												<div className="checkbox-items">
													<div
														className="checkbox-item"
														onClick={() => this.onChange(SHOW_PRICES.YES, 'show_prices')}
													>
														<input id="show-prices-yes"
															type="checkbox"
															checked={form.show_prices}
															onChange={() => this.onChange(SHOW_PRICES.YES, 'show_prices')}
														/>
														<label htmlFor="show-prices-yes">Sí</label>
													</div>

													<div
														className="checkbox-item"
														onClick={() => this.onChange(SHOW_PRICES.NO, 'show_prices')}
													>
														<input id="show-prices-no"
															type="checkbox"
															checked={!form.show_prices}
															onChange={() => this.onChange(SHOW_PRICES.NO, 'show_prices')}
														/>
														<label htmlFor="show-prices-no">No</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<section className="social-container">
									<p className="section-label">Redes Sociales</p>
									<div className="row">
										<div className="col-md-4">
											<label>Facebook</label>
											<input
												placeholder="URL"
												name="facebook"
												value={form.facebook}
												onChange={this.onChangeEvent}
											/>
										</div>
										<div className="col-md-4">
											<label>Instagram</label>
											<input
												placeholder="URL"
												name="instagram"
												value={form.instagram}
												onChange={this.onChangeEvent}
											/>
										</div>
										<div className="col-md-4">
											<label>X</label>
											<input
												placeholder="URL"
												name="twitter"
												value={form.twitter}
												onChange={this.onChangeEvent}
											/>
										</div>
									</div>
								</section>

								<p className="section-label">Apariencia del sitio</p>
								<section>
									<div className="appearance row">
										<div className="col-md-5">
											<div className={`container-public-tab ${this.state.public_tab == PUBLIC_TABS.HEADER ? 'active' : ''}`} onClick={() => this.setPublicTab(PUBLIC_TABS.HEADER)}>
												<img src={TabBottom} className="tab-arrow" />
												<img src={PublicHeader} className="image" />
												<p>Barra del menú</p>
											</div>
											{
												this.state.public_tab == PUBLIC_TABS.HEADER && (
													<div className="public-tab-padding">
														<div className="control">
															<label>Color</label>
															<input
																type="color"
																name="header_bg"
																value={form.header_bg}
																onChange={this.onChangeEvent}
															/>
														</div>
													</div>
												)
											}
											<div className={`container-public-tab ${this.state.public_tab == PUBLIC_TABS.IMAGE ? 'active' : ''}`} onClick={() => this.setPublicTab(PUBLIC_TABS.IMAGE)}>
												<img src={TabBottom} className="tab-arrow" />
												<img src={PublicImage} className="image" />
												<p>Banner imagen</p>
											</div>
											{
												this.state.public_tab == PUBLIC_TABS.IMAGE && (
													<div className="public-tab-padding">
														<label style={{ fontSize: 12 }}>(medida sugerida 1900px por 400px, máximo 500KB)</label>
														<div className="banner-upload">
															<label className="banner-input">
																<div className="banner-preview">
																	<img
																		src={banner}
																		className={banner === PictureIcon ? 'placeholder' : ''}
																		onError={({ currentTarget }) => {
																			currentTarget.onerror = null;
																			currentTarget.classList.add('placeholder');
																			currentTarget.src = PictureIcon;
																		}}
																		alt="Banner"
																	/>
																</div>
																<input
																	type="file"
																	accept="image/*"
																	name="banner"
																	id="banner-image"
																	onChange={this.onUploadBanner}
																/>
															</label>
															<img
																src={TrashIcon}
																className="banner-upload__delete"
																alt="Eliminar"
																title="Eliminar banner"
																onClick={this.onRemoveBanner}
															/>
														</div>
													</div>
												)
											}
											<div className={`container-public-tab ${this.state.public_tab == PUBLIC_TABS.FOOTER ? 'active' : ''}`} onClick={() => this.setPublicTab(PUBLIC_TABS.FOOTER)}>
												<img src={TabBottom} className="tab-arrow" />
												<img src={PublicFooter} className="image" />
												<p>Footer</p>
											</div>
											{
												this.state.public_tab == PUBLIC_TABS.FOOTER && (
													<div className="public-tab-padding">
														<div className="control">
															<label>Color</label>
															<input
																type="color"
																name="footer_bg"
																value={form.footer_bg}
																onChange={this.onChangeEvent}
															/>
														</div>
													</div>
												)
											}
										</div>
										<div className="col-md-7">
											<div className="preview">
												{this.state.currentURL !== ENV.BaseStore ? (
													<StorePreview currentURL={this.state.currentURL} store_session={this.state.store_session} />
												) : (
													<p>No tiene URL de la tienda para mostrar</p>
												)}
											</div>
										</div>
									</div>
									<button className="save-btn primary" onClick={this.onSubmit}>
										<span>GUARDAR</span>
									</button>
								</section>
							</section>
						</main>
					)}

					{tab === TABS.GENERAL_CONFIGS && (
						<main className="business-tab">
							<section className="catalogue">
								<div className="container-tab-settings">
									<div className={`tab-settings ${this.state.tab_settings == SETTINGS_TABS.GENERAL ? 'active' : ''}`} onClick={() => this.setSettingsTab(SETTINGS_TABS.GENERAL)}>
										<p>Generales</p>
									</div>
									<div className={`tab-settings ${this.state.tab_settings == SETTINGS_TABS.API ? 'active' : ''}`} onClick={() => this.setSettingsTab(SETTINGS_TABS.API)}>
										<p>Integración API</p>
									</div>
									<div className={`tab-settings ${this.state.tab_settings == SETTINGS_TABS.CUSTOM ? 'active' : ''}`} onClick={() => this.setSettingsTab(SETTINGS_TABS.CUSTOM)}>
										<p>Personalizadas</p>
									</div>
									<div className={`tab-settings ${this.state.tab_settings == SETTINGS_TABS.DISCOUNTS ? 'active' : ''}`} onClick={() => this.setSettingsTab(SETTINGS_TABS.DISCOUNTS)}>
										<p>Descuentos</p>
									</div>
									<div className={`tab-settings ${this.state.tab_settings == SETTINGS_TABS.COMMISSIONS ? 'active' : ''}`} onClick={() => this.setSettingsTab(SETTINGS_TABS.COMMISSIONS)}>
										<p>Comisiones</p>
									</div>
								</div>
							</section>
						</main>
					)}

					{
						tab === TABS.GENERAL_CONFIGS && this.state.tab_settings == SETTINGS_TABS.GENERAL && (
							<p className="section-label" style={{ textAlign: 'center' }}>Impresora por defecto en notas de entrega</p>
						)
					}
					<PrinterType ref={this.printerTypeComponent} visible={tab === TABS.GENERAL_CONFIGS && this.state.tab_settings == SETTINGS_TABS.GENERAL} />

					{tab === TABS.GENERAL_CONFIGS && (
						<main className="business-tab">
							<section className="catalogue">
								<section>
									{
										this.state.tab_settings == SETTINGS_TABS.GENERAL && (
											<>
												<section className="social-container">
													<p className="section-label" style={{ textAlign: 'center' }}>{this.state.countryEquivalent.ivaAbbreviation} %</p>

													<div style={{ width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
														<div className="iva-container">
															<p>Porcentaje</p>
															<InputFormat
																name="percentage"
																thousandSeparator={true}
																allowNegative={false}
																isNumericString={true}
																decimalScale="2"
																value={this.state.form.percentage}
																onValueChange={this.changeIVA}
															/>
														</div>
													</div>
												</section>

												<p className="section-label">Métodos de Pago</p>

												<div className="container-methods">
													<div className="row">
														{
															this.state.methods.map((item, index) => {
																return (
																	<div className="col-md-4">
																		<div className="item-check-method" onClick={() => this.setMethodActive(index)}>
																			<div className={`check ${item.active ? 'active' : ''}`}></div>
																			<p>{item.name}</p>
																		</div>
																	</div>
																)
															})
														}
													</div>
												</div>
											</>
										)
									}

									{
										this.state.tab_settings == SETTINGS_TABS.API && (
											<>
												<ApiGuide />
											</>
										)
									}

									{
										this.state.tab_settings == SETTINGS_TABS.CUSTOM && (
											<>

												{/*<div className="container-tabs-custom">
													<div className="container-buttons">
														<button
															className={tab_custom === TABS_CUSTOM.ACCOUNTS ? 'active': ''}
															onClick={() => this.setTabCustom(TABS_CUSTOM.ACCOUNTS)}
														>
															Cuentas por cobrar/descuentos
														</button>
														<button
															className={tab_custom === TABS_CUSTOM.SELL ? 'active': ''}
															onClick={() => this.setTabCustom(TABS_CUSTOM.SELL)}
														>
															Metas de venta
														</button>
														<button
															className={tab_custom === TABS_CUSTOM.COMMISSIONS ? 'active': ''}
															onClick={() => this.setTabCustom(TABS_CUSTOM.COMMISSIONS)}
														>
															Comisiones
														</button>
													</div>
												</div>*/}

												{
													tab_custom == TABS_CUSTOM.ACCOUNTS && (
														<div className="custom-container">
															<h3 className="custom-title">Cuentas por cobrar</h3>
															<div className="item-check">
																<div className="check"></div>
																<p>Autorizar a los usuarios señalados, acceso a cuentas por cobrar para editar campos determinados en pedidos procesados:</p>
															</div>
															<div className="custom-white row">
																<div className="col-md-6">
																	<h4>Usuarios</h4>
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Moderadores</p>
																	</div>
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Vendedores</p>
																	</div>
																</div>
																<div className="col-md-6">
																	<h4>Campos de pedidos a editar</h4>
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Días crédito</p>
																	</div>
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Porcentaje de descuento general</p>
																	</div>
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Porcentaje de descuento por volúmenes de productos</p>
																	</div>
																</div>
															</div>
															<div className="separator"></div>
															<h3 className="custom-title">Descuentos a clientes</h3>
															<div className="row">
																<div className="col-md-8">
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Aplicar descuentos por pronto pago a clientes que acepten plazo de pago:</p>
																	</div>
																</div>
																<div className="col-md-4">
																	<button className="btn-range">
																		<div className="container-add">
																			<img src={AddIcon} />
																		</div>
																		<p>Agregar rango</p>
																	</button>
																</div>
															</div>
															<div className="item-check margin-left">
																<div className="check"></div>
																<p>
																	Rango 1: De
																	<div className="form-group">
																		<label>Días</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	a
																	<div className="form-group">
																		<label>Días</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	otorgan descuento de
																	<div className="form-group">
																		<label>%</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	en monto de pedido
																</p>
															</div>
														</div>
													)
												}

												{
													tab_custom == TABS_CUSTOM.SELL && (
														<div className="custom-container personalizadas-table-container">

															{/* ===== SECCIÓN: CONDICIONES DE VENTA ===== */}
															<div style={{ background: '#fff', borderRadius: '10px', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
																<div className="custom-title-wrapper">
																	<div className="icon-circle" style={{ background: '#e6f0ff' }}>
																		<Icon name="money" style={{ color: '#2563eb' }} />
																	</div>
																	<h3 className="custom-title">Condiciones de venta</h3>
																</div>
																<p style={{ color: '#666', fontSize: '13px', marginBottom: '16px', marginTop: '-4px' }}>
																	Define qué condiciones pueden gestionar los vendedores al registrar una venta.
																</p>

																{/* Opción 1: Descuentos en ventas */}
																<div className="custom-option-row">
																	<div className="icon-wrapper">
																		<Icon name="check-square-o" />
																	</div>
																	<div style={{ flex: 1 }}>
																		<p className="option-text" style={{ margin: 0 }}>
																			Descuentos en ventas: <strong>¿Permitir que los vendedores apliquen descuentos al total de la venta?</strong>
																		</p>
																		<p style={{ color: '#888', fontSize: '12px', margin: '2px 0 0 0' }}>
																			nota: Al habilitar esta opción, los vendedores podrán ingresar un porcentaje de descuento al registrar una venta.
																		</p>
																	</div>
																	<div className="radio-group">
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ALLOW_SELLER_DISCOUNT.YES, 'allow_seller_discount')}
																		>
																			<div className={`radio-circle ${form.allow_seller_discount === ALLOW_SELLER_DISCOUNT.YES ? 'active' : ''}`}></div>
																			<span>Si</span>
																		</div>
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ALLOW_SELLER_DISCOUNT.NO, 'allow_seller_discount')}
																		>
																			<div className={`radio-circle ${form.allow_seller_discount === ALLOW_SELLER_DISCOUNT.NO ? 'active' : ''}`}></div>
																			<span>No</span>
																		</div>
																	</div>
																</div>

																{/* Opción 1.1: Descuentos por producto */}
																<div className="custom-option-row">
																	<div className="icon-wrapper">
																		<Icon name="check-square-o" />
																	</div>
																	<div style={{ flex: 1 }}>
																		<p className="option-text" style={{ margin: 0 }}>
																			Descuentos por producto: <strong>¿Permitir que los vendedores apliquen descuentos a productos individuales?</strong>
																		</p>
																		<p style={{ color: '#888', fontSize: '12px', margin: '2px 0 0 0' }}>
																			Al habilitar esta opción, los vendedores podrán ingresar un porcentaje de descuento de forma individual a los productos incluidos en la venta.
																		</p>
																	</div>
																	<div className="radio-group">
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ALLOW_SELLER_PRODUCT_DISCOUNT.YES, 'allow_seller_product_discount')}
																		>
																			<div className={`radio-circle ${form.allow_seller_product_discount === ALLOW_SELLER_PRODUCT_DISCOUNT.YES ? 'active' : ''}`}></div>
																			<span>Si</span>
																		</div>
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ALLOW_SELLER_PRODUCT_DISCOUNT.NO, 'allow_seller_product_discount')}
																		>
																			<div className={`radio-circle ${form.allow_seller_product_discount === ALLOW_SELLER_PRODUCT_DISCOUNT.NO ? 'active' : ''}`}></div>
																			<span>No</span>
																		</div>
																	</div>
																</div>

																{/* Opción 2: Plazo de crédito */}
																<div className="custom-option-row">
																	<div className="icon-wrapper">
																		<Icon name="check-square-o" />
																	</div>
																	<div style={{ flex: 1 }}>
																		<p className="option-text" style={{ margin: 0 }}>
																			Plazo de crédito: <strong>¿Permitir que los vendedores definan los días de crédito?</strong>
																		</p>
																		<p style={{ color: '#888', fontSize: '12px', margin: '2px 0 0 0' }}>
																			Al marcar Sí, cada vendedor podrá indicar o establecer el plazo de crédito al momento de registrar una venta por cobrar.
																		</p>
																	</div>
																	<div className="radio-group">
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ALLOW_SELLER_CREDIT_DAYS.YES, 'allow_seller_credit_days')}
																		>
																			<div className={`radio-circle ${form.allow_seller_credit_days === ALLOW_SELLER_CREDIT_DAYS.YES ? 'active' : ''}`}></div>
																			<span>Si</span>
																		</div>
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ALLOW_SELLER_CREDIT_DAYS.NO, 'allow_seller_credit_days')}
																		>
																			<div className={`radio-circle ${form.allow_seller_credit_days === ALLOW_SELLER_CREDIT_DAYS.NO ? 'active' : ''}`}></div>
																			<span>No</span>
																		</div>
																	</div>
																</div>

																{/* Opción 3: Días de crédito por empresa (condicional: solo si allow_seller_credit_days === NO) */}
																{form.allow_seller_credit_days === ALLOW_SELLER_CREDIT_DAYS.NO && (
																	<div className="custom-option-row" style={{ alignItems: 'center' }}>
																		<div className="icon-wrapper">
																			<Icon name="check-square-o" />
																		</div>
																		<div style={{ flex: 1 }}>
																			<p className="option-text" style={{ margin: 0 }}>
																				Días de crédito: <strong>días de crédito establecidos por la empresa</strong>
																			</p>
																			<p style={{ color: '#888', fontSize: '12px', margin: '2px 0 0 0' }}>
																				Este plazo se aplicará automáticamente a las ventas por cobrar y no podrá ser modificado por el vendedor.
																			</p>
																		</div>
																		<div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '120px' }}>
																			<input
																				type="number"
																				min="0"
																				value={form.seller_credit_days_default}
																				onChange={(e) => this.onChange(e.target.value, 'seller_credit_days_default')}
																				style={{
																					width: '70px',
																					padding: '6px 10px',
																					border: '1px solid #ccc',
																					borderRadius: '6px',
																					textAlign: 'center',
																					fontSize: '14px',
																				}}
																			/>
																			<span style={{ fontSize: '13px', color: '#555' }}>días</span>
																		</div>
																	</div>
																)}
								{/* Opción 4: Límite de crédito */}
								<div className="custom-option-row">
									<div className="icon-wrapper">
										<Icon name="check-square-o" />
									</div>
									<div style={{ flex: 1 }}>
										<p className="option-text" style={{ margin: 0 }}>
											Límite de crédito: <strong>¿Impedir ventas a crédito que superen el límite disponible del cliente?</strong>
										</p>
										<p style={{ color: '#888', fontSize: '12px', margin: '2px 0 0 0' }}>
											Esta restricción aplica únicamente a las ventas a crédito. Al activarla, los vendedores no podrán registrar pedidos cuyo saldo a crédito supere el límite disponible del cliente. Las ventas de contado no estarán sujetas a esta restricción.
										</p>
									</div>
									<div className="radio-group">
										<div
											className="radio-item"
											onClick={() => this.onChange(RESTRICT_CREDIT_LIMIT.YES, 'restrict_credit_limit')}
										>
											<div className={`radio-circle ${form.restrict_credit_limit === RESTRICT_CREDIT_LIMIT.YES ? 'active' : ''}`}></div>
											<span>Si</span>
										</div>
										<div
											className="radio-item"
											onClick={() => this.onChange(RESTRICT_CREDIT_LIMIT.NO, 'restrict_credit_limit')}
										>
											<div className={`radio-circle ${form.restrict_credit_limit === RESTRICT_CREDIT_LIMIT.NO ? 'active' : ''}`}></div>
											<span>No</span>
										</div>
									</div>
								</div>
															</div>

															{/* ===== SECCIÓN: INVENTARIO ===== */}
															<div style={{ background: '#fff', borderRadius: '10px', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
																<div className="custom-title-wrapper">
																	<div className="icon-circle blue">
																		<Icon name="cube" />
																	</div>
																	<h3 className="custom-title">Inventario</h3>
																</div>

																<div className="custom-option-row">
																	<div className="icon-wrapper">
																		<Icon name="check-square-o" />
																	</div>
																	<p className="option-text">¿El administrador debe aceptar los pedidos para descontar del inventario?</p>
																	<div className="radio-group">
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ACCEPT_ORDER_BEFORE.YES, 'accept_order_before')}
																		>
																			<div className={`radio-circle ${form.accept_order_before === ACCEPT_ORDER_BEFORE.YES ? 'active' : ''}`}></div>
																			<span>Si</span>
																		</div>
																		<div
																			className="radio-item"
																			onClick={() => this.onChange(ACCEPT_ORDER_BEFORE.NO, 'accept_order_before')}
																		>
																			<div className={`radio-circle ${form.accept_order_before === ACCEPT_ORDER_BEFORE.NO ? 'active' : ''}`}></div>
																			<span>No</span>
																		</div>
																	</div>
																</div>

																{this.props.user.level_id === Constants.ROLE_ADMIN && (
																	<>
																		<div className="custom-option-row">
																			<div className="icon-wrapper">
																				<Icon name="search" />
																			</div>
																			<p className="option-text">Permitir a los vendedores usar clientes sin zona</p>
																			<div className="radio-group">
																				<div
																					className="radio-item"
																					onClick={() => this.onChange(USE_NULL_ZONES.YES, 'use_null_zones')}
																				>
																					<div className={`radio-circle ${form.use_null_zones === USE_NULL_ZONES.YES ? 'active' : ''}`}></div>
																					<span>Si</span>
																				</div>
																				<div
																					className="radio-item"
																					onClick={() => this.onChange(USE_NULL_ZONES.NO, 'use_null_zones')}
																				>
																					<div className={`radio-circle ${form.use_null_zones === USE_NULL_ZONES.NO ? 'active' : ''}`}></div>
																					<span>No</span>
																				</div>
																			</div>
																		</div>
																		{form.use_null_zones === USE_NULL_ZONES.YES && (
																			<p style={{ color: Colors.red, fontSize: 14, marginTop: 0 }}>
																				Si la zona del vendedor es nula podrá visualizar los clientes sin zona asignada
																			</p>
																		)}
																	</>
																)}

																{this.props.user.level_id === Constants.ROLE_ADMIN && (
																	<>
																		<div className="custom-option-row">
																			<div className="icon-wrapper">
																				<Icon name="search" />
																			</div>
																			<p className="option-text">Declarar ilimitado las existencias del inventario</p>
																			<div className="radio-group">
																				<div
																					className="radio-item"
																					onClick={() => this.onChange(NEGATIVE_STOCK.YES, 'negative_stock')}
																				>
																					<div className={`radio-circle ${form.negative_stock === NEGATIVE_STOCK.YES ? 'active' : ''}`}></div>
																					<span>Si</span>
																				</div>
																				<div
																					className="radio-item"
																					onClick={() => this.onChange(NEGATIVE_STOCK.NO, 'negative_stock')}
																				>
																					<div className={`radio-circle ${form.negative_stock === NEGATIVE_STOCK.NO ? 'active' : ''}`}></div>
																					<span>No</span>
																				</div>
																			</div>
																		</div>
																		{form.negative_stock === NEGATIVE_STOCK.YES && (
																			<p style={{ color: Colors.red, fontSize: 14, marginTop: 0 }}>
																				La aplicación de esta función creará un comportamiento donde no se validarán las existencias de los inventarios
																			</p>
																		)}
																	</>
																)}

																{this.props.user.level_id === Constants.ROLE_ADMIN && (
																	<>
																		<ProductsPromotedList user_id={this.props.user.id} />
																		<ProductsLimitedList user_id={this.props.user.id} />
																	</>
																)}
															</div>

															{this.props.user.level_id === Constants.ROLE_ADMIN && (
																<div style={{ background: '#fff', borderRadius: '10px', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
																	<div className="custom-title-wrapper">
																		<div className="icon-circle green">
																			<Icon name="truck" />
																		</div>
																		<h3 className="custom-title">Despachos</h3>
																	</div>
																	<div className="custom-option-row">
																		<p className="option-text">Mostrar monto total en despachos</p>
																		<div className="radio-group">
																			<div
																				className="radio-item"
																				onClick={() => this.onChange(SHOW_ORDER_TOTAL.YES, 'show_order_total')}
																			>
																				<div className={`radio-circle ${form.show_order_total === SHOW_ORDER_TOTAL.YES ? 'active' : ''}`}></div>
																				<span>Si</span>
																			</div>
																			<div
																				className="radio-item"
																				onClick={() => this.onChange(SHOW_ORDER_TOTAL.NO, 'show_order_total')}
																			>
																				<div className={`radio-circle ${form.show_order_total === SHOW_ORDER_TOTAL.NO ? 'active' : ''}`}></div>
																				<span>No</span>
																			</div>
																		</div>
																	</div>
																</div>
															)}

															<div style={{ marginTop: '20px' }}></div>
														</div>
													)
												}

												{
													tab_custom == TABS_CUSTOM.COMMISSIONS && (
														<div className="custom-container">
															<h3 className="custom-title">Comisiones de Vendedores</h3>
															<div className="row row-check">
																<div className="col-md-8">
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Aplicar comisiones para vendedores según los plazos de pago a pedidos:</p>
																	</div>
																</div>
																<div className="col-md-4">
																	<button className="btn-range">
																		<div className="container-add">
																			<img src={AddIcon} />
																		</div>
																		<p>Agregar rango</p>
																	</button>
																</div>
															</div>
															<div className="item-check margin-left">
																<div className="check"></div>
																<p>
																	Si el período de pago es
																	<div className="form-group">
																		<label>días</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	hasta
																	<div className="form-group">
																		<label>días</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	otorgan comisión de
																	<div className="form-group">
																		<label>%</label>
																		<input
																			onChange={() => { }} />
																	</div>
																</p>
															</div>
															<div style={{ marginTop: '20px' }}></div>
															<div className="separator"></div>
															<h3 className="custom-title">Comisiones de Gerentes</h3>
															<div className="row row-check">
																<div className="col-md-8">
																	<div className="item-check">
																		<div className="check"></div>
																		<p>Aplicar comisiones para gerentes según los plazos de pago a pedidos:</p>
																	</div>
																</div>
																<div className="col-md-4">
																	<button className="btn-range">
																		<div className="container-add">
																			<img src={AddIcon} />
																		</div>
																		<p>Agregar rango</p>
																	</button>
																</div>
															</div>
															<div className="item-check margin-left">
																<div className="check"></div>
																<p>
																	Si el período de pago es
																	<div className="form-group">
																		<label>días</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	hasta
																	<div className="form-group">
																		<label>días</label>
																		<input
																			onChange={() => { }} />
																	</div>
																	otorgan comisión de
																	<div className="form-group">
																		<label>%</label>
																		<input
																			onChange={() => { }} />
																	</div>
																</p>
															</div>
															<div style={{ marginTop: '20px' }}></div>
														</div>
													)
												}
											</>
										)
									}

									{
										this.state.tab_settings == SETTINGS_TABS.DISCOUNTS && (
											<div className="custom-container discounts-table-container">
												{this.props.user.level_id === Constants.ROLE_ADMIN && (
													<>
														{/* SECCIÓN DE DESCUENTOS GENERALES */}
														<div className="mt-4" style={{ background: '#fff', borderRadius: '10px', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.05)' }}>
															<div className="d-flex align-items-center mb-4">
																<div style={{ background: '#f0e6ff', borderRadius: '50%', padding: '10px', marginRight: '15px' }}>
																	<Icon name="tag" style={{ color: '#6f42c1', fontSize: '20px' }} />
																</div>
																<h3 className="custom-title m-0" style={{ fontWeight: 'bold' }}>Descuentos</h3>
															</div>

															<div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
																<h5 style={{ fontWeight: 'bold', margin: '0' }}>Lista de descuentos</h5>
																<div className="d-flex align-items-center" style={{ gap: '20px' }}>
																	<div className="d-flex align-items-center" style={{ gap: '10px' }}>
																		{/* <span style={{ whiteSpace: 'nowrap', lineHeight: '1' }}>Tipo de descuentos</span> */}
																		<div style={{ width: '200px', marginBottom: '0' }}>
																			{/* <Select
																				color=""
																				defaultname="Seleccione un tipo"
																				className="material"
																				labelClass="material"
																				style={{ marginBottom: '0' }}
																				options={this.state.list_discount_types}
																				value={this.state.discount_filter_type}
																				onChange={(e) => {
																					this.setState({ discount_filter_type: e.target.value, discount_page: 1 }, () => {
																						this.getDiscounts();
																					});
																				}}
																			/> */}
																		</div>
																	</div>
																	<Button
																		color="primary"
																		style={{ marginLeft: '40px' }}
																		onClick={() => this.setState({ showDiscountModal: true, selectedDiscount: null })}
																	>
																		+ Agregar descuento
																	</Button>
																</div>
															</div>

															{form.general_discounts && form.general_discounts.length > 0 ? (
																<>
																	<style>
																		{`
																			.custom-toggle-switch {
																				position: relative;
																				display: inline-block;
																				width: 44px;
																				height: 24px;
																				margin: 0;
																			}
																			.custom-toggle-switch input {
																				opacity: 0;
																				width: 0;
																				height: 0;
																			}
																			.toggle-slider {
																				position: absolute;
																				cursor: pointer;
																				top: 0; left: 0; right: 0; bottom: 0;
																				background-color: #ccc;
																				transition: 0.3s ease-in-out;
																				border-radius: 24px;
																			}
																			.toggle-slider:before {
																				position: absolute;
																				content: "";
																				height: 18px;
																				width: 18px;
																				left: 3px;
																				bottom: 3px;
																				background-color: white;
																				transition: 0.3s ease-in-out;
																				border-radius: 50%;
																				box-shadow: 0 2px 4px rgba(0,0,0,0.2);
																			}
																			.custom-toggle-switch input:checked + .toggle-slider {
																				background-color: #4cd964;
																			}
																			.custom-toggle-switch input:checked + .toggle-slider:before {
																				transform: translateX(20px);
																			}
																			.custom-toggle-switch input:focus-visible + .toggle-slider {
																				outline: 2px solid #005fcc;
																				outline-offset: 2px;
																			}
																		`}
																	</style>
																	<Table
																		header={['Fecha de creación', 'Nombre', 'Tipo de descuento', 'Estatus', 'Acciones']}
																		data={form.general_discounts.length}
																	>
																		{form.general_discounts.map((discount, index) => (
																			<tr key={discount.id || `temp-${index}`}>
																				<td>{moment(discount.created_at).format('DD-MM-YYYY')}</td>
																				<td>{discount.name}</td>
																				<td>{this.getDiscountTypeBadge(discount)}</td>
																				<td>
																					<div className="d-flex align-items-center" style={{ gap: '10px' }}>
																						<label
																							className="custom-toggle-switch"
																							title={discount.status === Constants.STATUS_ACTIVE ? "Desactivar" : "Activar"}
																						>
																							<input
																								type="checkbox"
																								checked={discount.status === Constants.STATUS_ACTIVE}
																								onChange={() => this.changeStatusDiscount(discount, index)}
																								aria-label={`Cambiar estado de ${discount.name || 'este descuento'}`}
																								aria-checked={discount.status === Constants.STATUS_ACTIVE}
																							/>
																							<span className="toggle-slider"></span>
																						</label>
																						<span style={{ fontSize: '14px', color: discount.status === Constants.STATUS_ACTIVE ? '#28a745' : '#dc3545' }}>
																							{discount.status_text || (discount.status === Constants.STATUS_ACTIVE ? 'Activo' : 'Inactivo')}
																						</span>
																					</div>
																				</td>
																				<td style={{ textAlign: 'right' }}>
																					<div className="d-flex justify-content-end align-items-center" style={{ gap: '15px' }}>
																						<span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => this.setState({ showDiscountModal: true, selectedDiscount: discount })}>
																							<Icon name="edit" />
																						</span>
																						<span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => this.removeDiscount(index)}>
																							<Icon name="trash" />
																						</span>
																					</div>
																				</td>
																			</tr>
																		))}
																	</Table>

																	<Pagination
																		pages={this.state.discount_last_page}
																		active={this.state.discount_page}
																		onChange={page => {
																			this.setState({ discount_page: page }, () => {
																				this.getDiscounts(page);
																			});
																		}}
																	/>
																</>
															) : (
																<div className="alert alert-info mt-3">
																	No hay descuentos registrados
																</div>
															)}
														</div>
													</>
												)}
											</div>
										)
									}

									{
										this.state.tab_settings == SETTINGS_TABS.COMMISSIONS && (
											<div className="custom-container commissions-table-container">
												{this.props.user.level_id === Constants.ROLE_ADMIN && (
													<>
														<div className="mt-4" style={{ background: '#fff', borderRadius: '10px', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.05)' }}>
															<div className="d-flex justify-content-between align-items-center mb-4">
																<div className="d-flex align-items-center">
																	<div style={{ background: '#fff0e6', borderRadius: '50%', padding: '10px', marginRight: '15px' }}>
																		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fd7e14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
																	</div>
																	<h3 className="custom-title m-0" style={{ fontWeight: 'bold' }}>Comisiones</h3>
																</div>
																<Button
																	color="primary"
																	onClick={() => this.setState({ showCommissionModal: true, selectedCommission: null })}
																>
																	+ Agregar comisión
																</Button>
															</div>

															{/* Vendedores */}
															<div className="d-flex align-items-center mb-3 mt-4" style={{ paddingLeft: '10px' }}>
																<div style={{ background: '#e6f2ff', borderRadius: '50%', padding: '8px', marginRight: '10px', display: 'flex' }}>
																	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#007bff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
																</div>
																<h5 style={{ fontWeight: 'bold', margin: '0' }}>Vendedores</h5>
															</div>

															<div className="table-responsive">
																<table className="table table-borderless" style={{ borderCollapse: 'separate', borderSpacing: '0 0', width: '100%' }}>
																	<thead>
																		<tr>
																			<th style={{ background: '#eaf4ff', borderRadius: '8px 0 0 8px', width: '200px', verticalAlign: 'middle', fontWeight: 'bold', color: '#000', paddingLeft: '20px' }}>Periodo de pago</th>
																			<th style={{ background: '#eaf4ff', width: '100px', verticalAlign: 'middle', fontWeight: '600', color: '#6c757d', textAlign: 'center' }}>Desde</th>
																			<th style={{ background: '#eaf4ff', borderRadius: '0 8px 8px 0', width: '100px', verticalAlign: 'middle', fontWeight: '600', color: '#6c757d', textAlign: 'center' }}>Hasta</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Tipo de comisión</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Comisión %</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Categoría/Producto</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Código de producto</th>
																			<th></th>
																		</tr>
																	</thead>
																	<tbody>
																		{this.state.sellers_commissions.map((detail, index) => (
																			<tr key={detail.id || `vend-${index}`}>
																				<td style={{ borderBottom: '1px solid #e9ecef', padding: '15px 10px' }}></td>
																				<td style={{ borderBottom: '1px solid #e9ecef', textAlign: 'center', verticalAlign: 'middle' }}>{detail.from_days || '-'}</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', textAlign: 'center', verticalAlign: 'middle' }}>{detail.to_days || '-'}</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>
																					{this.getCommissionTypeBadge(detail.commission?.type)}
																				</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>{detail.percentage}</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>
																					{String(detail.commission?.type) === '2' ? (detail.category?.name || '-') : String(detail.commission?.type) === '3' ? (detail.product?.name || '-') : '-'}
																				</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>
																					{String(detail.commission?.type) === '3' ? (detail.product?.code || '-') : '-'}
																				</td>

																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle', textAlign: 'right' }}>
																					<div className="d-flex justify-content-end align-items-center" style={{ gap: '15px' }}>
																						<span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => this.setState({ showCommissionModal: true, selectedCommission: detail.commission })}><Icon name="edit" /></span>
																						<span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => this.removeCommission(detail.commission?.id)}><Icon name="trash" /></span>
																						<div className="custom-control custom-switch">
																							<input type="checkbox" className="custom-control-input" id={`switch-vend-${index}`} checked={detail.commission?.is_active === 1} onChange={() => this.toggleCommissionStatus(detail)} />
																							<label className="custom-control-label" htmlFor={`switch-vend-${index}`}></label>
																						</div>
																					</div>
																				</td>
																			</tr>
																		))}
																		{this.state.sellers_commissions.length === 0 && (
																			<tr><td colSpan="8" className="text-center text-muted py-3">No hay comisiones de vendedores registradas</td></tr>
																		)}
																	</tbody>
																</table>
															</div>

															{/* Gerentes */}
															<div className="d-flex align-items-center mb-3 mt-5" style={{ paddingLeft: '10px' }}>
																<div style={{ background: '#e6f2ff', borderRadius: '50%', padding: '8px', marginRight: '10px', display: 'flex' }}>
																	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
																</div>
																<h5 style={{ fontWeight: 'bold', margin: '0' }}>Gerentes</h5>
															</div>

															<div className="table-responsive">
																<table className="table table-borderless" style={{ borderCollapse: 'separate', borderSpacing: '0 0', width: '100%' }}>
																	<thead>
																		<tr>
																			<th style={{ background: '#eaf4ff', borderRadius: '8px 0 0 8px', width: '200px', verticalAlign: 'middle', fontWeight: 'bold', color: '#000', paddingLeft: '20px' }}>Periodo de pago</th>
																			<th style={{ background: '#eaf4ff', width: '100px', verticalAlign: 'middle', fontWeight: '600', color: '#6c757d', textAlign: 'center' }}>Desde</th>
																			<th style={{ background: '#eaf4ff', borderRadius: '0 8px 8px 0', width: '100px', verticalAlign: 'middle', fontWeight: '600', color: '#6c757d', textAlign: 'center' }}>Hasta</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Tipo de comisión</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Comisión %</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Categoría/Producto</th>
																			<th style={{ verticalAlign: 'middle', fontWeight: 'bold', color: '#333' }}>Código de producto</th>
																			<th></th>
																		</tr>
																	</thead>
																	<tbody>
																		{this.state.managers_commissions.map((detail, index) => (
																			<tr key={detail.id || `ger-${index}`}>
																				<td style={{ borderBottom: '1px solid #e9ecef', padding: '15px 10px' }}></td>
																				<td style={{ borderBottom: '1px solid #e9ecef', textAlign: 'center', verticalAlign: 'middle' }}>{detail.from_days || '-'}</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', textAlign: 'center', verticalAlign: 'middle' }}>{detail.to_days || '-'}</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>
																					{this.getCommissionTypeBadge(detail.commission?.type)}
																				</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>{detail.percentage}</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>
																					{String(detail.commission?.type) === '2' ? (detail.category?.name || '-') : String(detail.commission?.type) === '3' ? (detail.product?.name || '-') : '-'}
																				</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle' }}>
																					{String(detail.commission?.type) === '3' ? (detail.product?.code || '-') : '-'}
																				</td>
																				<td style={{ borderBottom: '1px solid #e9ecef', verticalAlign: 'middle', textAlign: 'right' }}>
																					<div className="d-flex justify-content-end align-items-center" style={{ gap: '15px' }}>
																						<span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => this.setState({ showCommissionModal: true, selectedCommission: detail.commission })}><Icon name="edit" /></span>
																						<span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => this.removeCommission(detail.commission?.id)}><Icon name="trash" /></span>
																						<div className="custom-control custom-switch">
																							<input type="checkbox" className="custom-control-input" id={`switch-ger-${index}`} checked={detail.commission?.is_active === 1} onChange={() => this.toggleCommissionStatus(detail)} />
																							<label className="custom-control-label" htmlFor={`switch-ger-${index}`}></label>
																						</div>
																					</div>
																				</td>
																			</tr>
																		))}
																		{this.state.managers_commissions.length === 0 && (
																			<tr><td colSpan="8" className="text-center text-muted py-3">No hay comisiones de gerentes registradas</td></tr>
																		)}
																	</tbody>
																</table>
															</div>
														</div>
													</>
												)}
											</div>
										)
									}

									{
										(this.state.tab_settings === SETTINGS_TABS.GENERAL) && (
											<button className="save-btn primary" onClick={this.onSubmit}>
												<span>GUARDAR</span>
											</button>
										)
									}
								</section>

							</section>
						</main>
					)}
				</div>
				<ModalDiscount
					show={this.state.showDiscountModal}
					onHide={() => this.setState({ showDiscountModal: false, selectedDiscount: null })}
					discount={this.state.selectedDiscount}
					user_id={this.props.user.id}
					discountTypes={this.state.list_discount_types}
					onSuccess={() => {
						this.setState({ showDiscountModal: false, selectedDiscount: null });
						this.getDiscounts(this.state.discount_page);
					}}
				/>
				<ModalCommission
					show={this.state.showCommissionModal}
					onHide={() => this.setState({ showCommissionModal: false, selectedCommission: null })}
					commission={this.state.selectedCommission}
					user_id={this.props.user.id}
					commissionTypes={this.state.list_commission_types}
					sellers_commissions={this.state.sellers_commissions}
					managers_commissions={this.state.managers_commissions}
					onSuccess={() => {
						this.setState({ showCommissionModal: false, selectedCommission: null });
						this.getCommissions(this.state.commission_page_sellers, this.state.commission_page_managers);
					}}
				/>
			</Menu>
		);
	}
}

const StorePreview = React.memo(({ currentURL, store_session }) => (
	<iframe
		title="Vista previa"
		src={`${currentURL}${Globals.toParams({ store_session })}`}
	/>
))

export default connect(state => {
	return {
		user: state.user
	};
})(MyProfileAccount);
